import { BUILTIN_TOOL_NAMES } from '@klook/admin-ai-assistant'
import { getActPageTypeKey, PAGE_TYPE_KEY_DICT } from '@klook/admin-ai-workflow-contracts'

// 工具名单一来源：workflow steps 与组件侧 v-tool-register 都引用本常量，避免裸字符串两侧 drift。
export const TOOL_NAMES = {
  SEARCH_ACT_LIST: 'wf:searchActListById',
  SEARCH_PACKAGE_LIST: 'wf:searchPackageListById',
  UPDATE_TIMESLOT_INV: 'wf:update_inventory:updateTimesoltInv',
  HIGHLIGHT_CONFIRM: 'wf:update_inventory:highlightConfirm',

  OPEN_AID_BULK_EDIT: 'wf:price_inv_drawer:openAidBulkEdit',
  OPEN_TTD_EDIT_SCHEDULE: 'wf:price_inv_drawer:openTtdEditSchedule',
  SET_DRAWER_SKU_IDS: 'wf:price_inv_drawer:setSkuIds',
  SET_DRAWER_DATE_RANGE: 'wf:price_inv_drawer:setDateRange',
  UPDATE_DRAWER_INVENTORY: 'wf:price_inv_drawer:updateInventory',
  UPDATE_DRAWER_PRICE: 'wf:price_inv_drawer:updatePrice',
  HIGHLIGHT_DRAWER_CONFIRM: 'wf:price_inv_drawer:highlightConfirm',

  OPEN_TTD_FIXED_PRICE_SETTINGS: 'wf:update_price:openTtdFixedPriceSettings',
  SET_TTD_FIXED_COST_PRICE: 'wf:update_price:setTtdFixedCostPrice',
  HIGHLIGHT_TTD_FIXED_PRICE_CONFIRM: 'wf:update_price:highlightTtdFixedPriceConfirm',
  OPEN_AID_FIXED_PRICE_DRAWER: 'wf:update_price:openAidFixedPriceDrawer',
  SET_AID_FIXED_COST_PRICE: 'wf:update_price:setAidFixedCostPrice',
  HIGHLIGHT_AID_FIXED_PRICE_CONFIRM: 'wf:update_price:highlightAidFixedPriceConfirm',

  SET_TTD_TOTAL_INVENTORY: 'wf:update_inventory:setTtdTotalInventory',
  SET_AID_TOTAL_INVENTORY: 'wf:update_inventory:setAidTotalInventory',

  SET_CONFIRMATION_TIME: 'wf:toggle_instant_confirm:setConfirmationTime',

  SET_CANCELLATION_POLICY: 'wf:set_cancel_policy:setCancellationPolicy',

  OPEN_AID_ITEM_GROUP_MODAL: 'wf:booking_num:openAidItemGroupModal',
  SET_AID_BOOKING_MIN: 'wf:booking_num:setAidBookingMin',
  SET_AID_BOOKING_MAX: 'wf:booking_num:setAidBookingMax',
  HIGHLIGHT_AID_ITEM_GROUP_CONFIRM: 'wf:booking_num:highlightAidItemGroupConfirm',
  SET_TTD_MIN_MAX_BOOKINGS: 'wf:booking_num:setTtdMinMaxBookings',

  OPEN_AID_MANAGE_STATUS: 'wf:toggle_date:openAidManageStatus',
  APPLY_AID_DRAWER: 'wf:toggle_date:applyAidDrawer',
  HIGHLIGHT_AID_DRAWER_CONFIRM: 'wf:toggle_date:highlightAidDrawerConfirm',
  OPEN_BULK_SCHEDULE_MENU: 'wf:toggle_date:openBulkScheduleMenu',
  TOGGLE_DATE_APPLY: 'wf:toggle_date:applyDates',
  TOGGLE_DATE_HIGHLIGHT_CONFIRM: 'wf:toggle_date:highlightConfirm',

  HOVER_ACT_MORE_POPOVER: 'wf:submit_audit:hoverActMorePopover',
  HIGHLIGHT_SUBMIT_ACTIVITY: 'wf:submit_audit:highlightSubmitActivity',

  HIGHLIGHT_ACT_STATUS_BTN: 'wf:update_status:highlightActStatusBtn',
  HIGHLIGHT_PKG_STATUS_BTN: 'wf:update_status:highlightPkgStatusBtn'
}

const ACTION_TO_BULK_KEY = {
  close: 'deactivate',
  open: 'activate'
}

function buildPriceInvDrawerSteps(kind) {
  const valueStepName = kind === 'price' ? TOOL_NAMES.UPDATE_DRAWER_PRICE : TOOL_NAMES.UPDATE_DRAWER_INVENTORY
  const valueStepDesc = kind === 'price' ? 'Update price' : 'Update inventory'
  return [
    {
      name: TOOL_NAMES.SET_DRAWER_SKU_IDS,
      description: 'Select SKU',
      waitTimeout: 15000
    },
    {
      name: TOOL_NAMES.SET_DRAWER_DATE_RANGE,
      description: 'Set date range',
      waitTimeout: 15000
    },
    {
      name: valueStepName,
      description: valueStepDesc,
      waitTimeout: 15000
    },
    {
      name: TOOL_NAMES.HIGHLIGHT_DRAWER_CONFIRM,
      description: 'Please click "Confirm" to save',
      waitTimeout: 15000
    }
  ]
}

function buildPriceInvWorkflowSteps(data, kind) {
  const pageTypeKey = getActPageTypeKey(data)
  const isAID = pageTypeKey === PAGE_TYPE_KEY_DICT.AID_ATT_ACT || pageTypeKey === PAGE_TYPE_KEY_DICT.AID_TOURS
  const openToolName = isAID ? TOOL_NAMES.OPEN_AID_BULK_EDIT : TOOL_NAMES.OPEN_TTD_EDIT_SCHEDULE

  return [
    {
      name: openToolName,
      description: 'Open price/inventory drawer',
      waitTimeout: 15000
    },
    ...buildPriceInvDrawerSteps(kind)
  ]
}

function buildFixedDrawerWorkflowSteps(data, kind) {
  const pageTypeKey = getActPageTypeKey(data)
  const isAID = pageTypeKey === PAGE_TYPE_KEY_DICT.AID_ATT_ACT || pageTypeKey === PAGE_TYPE_KEY_DICT.AID_TOURS
  const isPrice = kind === 'price'

  if (isAID) {
    return [
      {
        name: BUILTIN_TOOL_NAMES.CLICK_ELEMENT,
        description: 'Select target SKU',
        params: {
          selector: (intent, d) => `[data-sku-id="${d.sku_id}"]`
        }
      },
      {
        name: TOOL_NAMES.OPEN_AID_FIXED_PRICE_DRAWER,
        description: 'Open fixed price / total inventory drawer',
        waitTimeout: 15000
      },
      {
        name: isPrice ? TOOL_NAMES.SET_AID_FIXED_COST_PRICE : TOOL_NAMES.SET_AID_TOTAL_INVENTORY,
        description: isPrice ? 'Fill in cost price' : 'Fill in total inventory',
        waitTimeout: 15000
      },
      {
        name: TOOL_NAMES.HIGHLIGHT_AID_FIXED_PRICE_CONFIRM,
        description: 'Please click "Save" to confirm',
        waitTimeout: 15000
      }
    ]
  }

  return [
    {
      name: TOOL_NAMES.OPEN_TTD_FIXED_PRICE_SETTINGS,
      description: 'Open "Edit price and inventory rules" drawer',
      waitTimeout: 15000
    },
    {
      name: isPrice ? TOOL_NAMES.SET_TTD_FIXED_COST_PRICE : TOOL_NAMES.SET_TTD_TOTAL_INVENTORY,
      description: isPrice ? 'Fill in cost price' : 'Fill in total inventory',
      waitTimeout: 15000
    },
    {
      name: TOOL_NAMES.HIGHLIGHT_TTD_FIXED_PRICE_CONFIRM,
      description: 'Please click "Save" to confirm',
      waitTimeout: 15000
    }
  ]
}

const updateInventoryWorkflow = {
  trigger: 'auto',
  readyMode: 'lazy',
  scope: 'COMMON',
  description: 'Update activity inventory',
  steps(call) {
    const data = call.data || {}
    if (!data.activity_id) return []
    if (data.inv_model === 3) {
      return buildFixedDrawerWorkflowSteps(data, 'inventory')
    }
    return buildPriceInvWorkflowSteps(data, 'inventory')
  }
}

const updatePriceWorkflow = {
  trigger: 'auto',
  readyMode: 'lazy',
  scope: 'COMMON',
  description: 'Update activity price',
  steps(call) {
    const data = call.data || {}
    if (!data.activity_id) return []
    if (data.pricing_model === 0) {
      return buildFixedDrawerWorkflowSteps(data, 'price')
    }
    return buildPriceInvWorkflowSteps(data, 'price')
  }
}

const toggleDateWorkflow = {
  trigger: 'auto',
  readyMode: 'lazy',
  scope: 'COMMON',
  description: 'Bulk enable/disable date schedules',
  steps(call) {
    const data = call.data || {}
    const bulkKey = ACTION_TO_BULK_KEY[data.action]
    if (!data.activity_id || !Array.isArray(data.dates) || !data.dates.length || !bulkKey) {
      return []
    }

    const pageTypeKey = getActPageTypeKey(data)
    const isAID =
      pageTypeKey === PAGE_TYPE_KEY_DICT.AID_ATT_ACT || pageTypeKey === PAGE_TYPE_KEY_DICT.AID_TOURS

    if (isAID) {
      return [
        {
          name: BUILTIN_TOOL_NAMES.CLICK_ELEMENT,
          description: 'Select target SKU',
          // 不要传 target: 'iframe'：当前 executor 已运行在 iframe 上下文，
          // 再次 target:'iframe' 会让 CLICK_ELEMENT 找子 iframe，executeInIframe 无实现导致永久挂起。
          params: {
            selector: (intent, d) => `[data-sku-id="${d.sku_id}"]`
          }
        },
        {
          name: TOOL_NAMES.OPEN_AID_MANAGE_STATUS,
          description: 'Open Manage Status drawer',
          waitTimeout: 15000
        },
        {
          name: TOOL_NAMES.APPLY_AID_DRAWER,
          description: 'Fill in dates and action type',
          params: { bulkKey },
          waitTimeout: 15000
        },
        {
          name: TOOL_NAMES.HIGHLIGHT_AID_DRAWER_CONFIRM,
          description: 'Please click Confirm to submit',
          waitTimeout: 15000
        }
      ]
    }

    return [
      {
        name: TOOL_NAMES.OPEN_BULK_SCHEDULE_MENU,
        description: `Select bulk ${data.action === 'close' ? 'disable' : 'enable'} menu`,
        params: { bulkKey },
        waitTimeout: 15000
      },
      {
        name: TOOL_NAMES.TOGGLE_DATE_APPLY,
        description: 'Fill dates into the form',
        waitTimeout: 15000
      },
      {
        name: TOOL_NAMES.TOGGLE_DATE_HIGHLIGHT_CONFIRM,
        description: 'Please click the button to submit',
        waitTimeout: 15000
      }
    ]
  }
}

const toggleInstantConfirmWorkflow = {
  trigger: 'auto',
  readyMode: 'lazy',
  scope: 'COMMON',
  description: 'Toggle instant confirmation',
  steps(call) {
    const data = call.data || {}
    if (!data.activity_id || data.confirmation_time == null) return []

    const pageTypeKey = getActPageTypeKey(data)
    const isAID =
      pageTypeKey === PAGE_TYPE_KEY_DICT.AID_ATT_ACT || pageTypeKey === PAGE_TYPE_KEY_DICT.AID_TOURS
    const saveSelector = isAID ? '.save_and_next_step' : '.js-edit-save-btn'

    return [
      {
        name: TOOL_NAMES.SET_CONFIRMATION_TIME,
        description: 'Set confirmation method',
        waitTimeout: 15000
      },
      {
        name: BUILTIN_TOOL_NAMES.HIGHLIGHT_ELEMENT,
        description: 'Please click the save button',
        params: { selector: saveSelector, label: 'Please click to save' },
        delay: 1000
      }
    ]
  }
}

const setCancelPolicyWorkflow = {
  trigger: 'auto',
  readyMode: 'lazy',
  scope: 'COMMON',
  description: 'Open the cancellation policy page and set the policy',
  steps(call) {
    const data = call.data || {}
    if (!data.activity_id || data.cancellation_type == null) return []

    const pageTypeKey = getActPageTypeKey(data)
    const isAID =
      pageTypeKey === PAGE_TYPE_KEY_DICT.AID_ATT_ACT || pageTypeKey === PAGE_TYPE_KEY_DICT.AID_TOURS
    const saveSelector = isAID ? '.save_and_next_step' : '.js-edit-save-btn'

    return [
      {
        name: TOOL_NAMES.SET_CANCELLATION_POLICY,
        description: 'Select cancellation policy option',
        waitTimeout: 15000
      },
      {
        name: BUILTIN_TOOL_NAMES.HIGHLIGHT_ELEMENT,
        description: 'Please click the save button',
        params: { selector: saveSelector, label: 'Please click to save' },
        delay: 1000
      }
    ]
  }
}

function buildUpdateBookingNumSteps(data) {
  const pageTypeKey = getActPageTypeKey(data)

  if (pageTypeKey === PAGE_TYPE_KEY_DICT.AID_ATT_ACT) return []

  if (pageTypeKey === PAGE_TYPE_KEY_DICT.AID_TOURS) {
    const hasMin = data.min_num != null
    const hasMax = data.max_num != null

    const steps = [
      {
        name: TOOL_NAMES.OPEN_AID_ITEM_GROUP_MODAL,
        description: 'Open booking limit modal',
        waitTimeout: 15000
      }
    ]
    if (hasMin) {
      steps.push({
        name: TOOL_NAMES.SET_AID_BOOKING_MIN,
        description: 'Set minimum booking number',
        waitTimeout: 15000
      })
    }
    if (hasMax) {
      steps.push({
        name: TOOL_NAMES.SET_AID_BOOKING_MAX,
        description: 'Set maximum booking number',
        waitTimeout: 15000
      })
    }
    steps.push({
      name: TOOL_NAMES.HIGHLIGHT_AID_ITEM_GROUP_CONFIRM,
      description: 'Please click "Confirm" to save',
      waitTimeout: 15000
    })
    return steps
  }

  return [
    {
      name: TOOL_NAMES.SET_TTD_MIN_MAX_BOOKINGS,
      description: 'Set min / max booking number',
      waitTimeout: 15000
    },
    {
      name: BUILTIN_TOOL_NAMES.HIGHLIGHT_ELEMENT,
      description: 'Please click the save button',
      params: { selector: '.js-edit-save-btn', label: 'Please click to save' },
      delay: 1000
    }
  ]
}

const updateMinMaxNumWorkflow = {
  trigger: 'auto',
  readyMode: 'lazy',
  scope: 'COMMON',
  description: 'Update min / max booking number',
  steps(call) {
    const data = call.data || {}
    if (!data.activity_id) return []
    if (data.min_num == null && data.max_num == null) return []
    return buildUpdateBookingNumSteps(data)
  }
}

const submitAuditWorkflow = {
  trigger: 'auto',
  readyMode: 'lazy',
  scope: 'COMMON',
  description: 'Submit for review',
  steps(call) {
    const data = call.data || {}
    if (!data.activity_id) return []

    const isPackage = data.audit_type === 'package'
    // 套餐场景必须带 package_id，缺失则跳过以免下游定位失败
    if (isPackage && !data.package_id) return []

    const entityLabel = isPackage ? 'package' : 'activity'

    return [
      {
        name: isPackage ? TOOL_NAMES.SEARCH_PACKAGE_LIST : TOOL_NAMES.SEARCH_ACT_LIST,
        description: `Switch to ${entityLabel} list and search`,
        waitTimeout: 15000
      },
      {
        name: TOOL_NAMES.HOVER_ACT_MORE_POPOVER,
        description: 'Expand the action menu',
        waitTimeout: 15000
      },
      {
        name: TOOL_NAMES.HIGHLIGHT_SUBMIT_ACTIVITY,
        description: `Please click the "Submit for review" button of the ${entityLabel}`,
        waitTimeout: 15000
      }
    ]
  }
}

const updateStatusWorkflow = {
  trigger: 'auto',
  readyMode: 'lazy',
  scope: 'COMMON',
  description: 'Update activity status',
  steps(call) {
    const data = call.data || {}
    if (!data.activity_id) return []
    if (data.action !== 'publish' && data.action !== 'unpublish') return []

    const pageTypeKey = getActPageTypeKey(data)
    if (pageTypeKey === PAGE_TYPE_KEY_DICT.AID_ATT_ACT) return []

    const isPackageTarget = data.target === 'package'
    const isTTDPkg = pageTypeKey === PAGE_TYPE_KEY_DICT.TTD_ACTIVITY && isPackageTarget

    if (isTTDPkg && !data.package_id) {
      return []
    }

    const steps = []
    if (isTTDPkg) {
      const lang = data.submitted_language || 'en_US'
      const route =
        `/act/package/info/${data.activity_id}` +
        `?lang=${lang}&package_type=-1&package_id=${data.package_id}`
      steps.push({
        name: BUILTIN_TOOL_NAMES.REDIRECT_ROUTER,
        description: 'Navigate to package info page',
        params: { route },
        waitTimeout: 15000
      })
    }

    steps.push({
      name: isTTDPkg ? TOOL_NAMES.HIGHLIGHT_PKG_STATUS_BTN : TOOL_NAMES.HIGHLIGHT_ACT_STATUS_BTN,
      description:
        data.action === 'publish' ? 'Please click the publish button' : 'Please click the unpublish button',
      waitTimeout: 15000
    })

    return steps
  }
}

export function registerWorkflows(ai) {
  ai.registerWorkflow('update_inventory', updateInventoryWorkflow)
  ai.registerWorkflow('update_price', updatePriceWorkflow)
  ai.registerWorkflow('toggle_date', toggleDateWorkflow)
  ai.registerWorkflow('toggle_instant_confirm', toggleInstantConfirmWorkflow)
  ai.registerWorkflow('set_cancel_policy', setCancelPolicyWorkflow)
  ai.registerWorkflow('update_min_max_num', updateMinMaxNumWorkflow)
  ai.registerWorkflow('submit_audit', submitAuditWorkflow)
  ai.registerWorkflow('update_status', updateStatusWorkflow)
}
